import React, { Component } from 'react';
import {List, ListItem} from 'material-ui/List';
import AccountCircle from 'material-ui/svg-icons/action/account-circle';
import Divider from 'material-ui/Divider';
import Avatar from 'material-ui/Avatar';
import Dot from 'material-ui/svg-icons/av/fiber-manual-record';
import Add from 'material-ui/svg-icons/content/add-circle';
import {greenA700} from 'material-ui/styles/colors'
import Subheader from 'material-ui/Subheader'
import FlatButton from 'material-ui/FlatButton';

import {grey500} from 'material-ui/styles/colors';
import { FormattedMessage } from 'react-intl';

class Contact extends Component {
  render() {
    const contact = this.props.contact;
    const hasConversation = this.props.activeConversation && this.props.activeConversation.id === contact.id;
    const messagesLength = contact.messages ? contact.messages.length : 0;
    const agent = contact.agent;

    return (<ListItem
      key={contact.id}
      style={
        hasConversation ? {fontWeight: 'bold', backgroundColor: "rgba(0, 0, 0, 0.1)"} : {}}
      onClick={(e) => this.props.onContactClick(contact)}
      primaryText={contact.name}
      secondaryText={
        <span style={{display:'block', position: 'relative'}}>
          <span style={{opacity:0.8, fontSize: '0.9em', whiteSpace: 'nowrap'}}>{(agent ? Object.values(agent.browser.name) : '')} {(agent ? Object.values(agent.os.name) : '')}</span>
          <br/>
          <span style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            position: 'absolute',
            width: '100%'
          }}>{(messagesLength ? contact.messages[messagesLength - 1].text  : '')}</span>
        </span>
      }
      secondaryTextLines={2}
      rightIcon={<Dot className="state" color={contact.online ? greenA700 : 'red'} />}
      leftAvatar={<Avatar icon={<AccountCircle />} />}
    />);
  }
}

class ContactList extends Component {
  render() {
    const contacts = this.props.contacts.map((contact) => {
      return (
        <Contact
          key={contact.id}
          contact={contact}
          onContactClick={this.props.onContactClick}
          activeConversation={this.props.activeConversation}
        />);
    }).reverse();

    return (
      <div>
        <List>
          <Subheader>{this.props.title}</Subheader>
          {contacts}
          {!contacts.length &&
            <ListItem disabled={true}>
              <FormattedMessage
                id="Supporter.ContactList.NoContact"
                defaultMessage="Kein Kontakt"
              />
            </ListItem>
          }
        </List>
        {!this.props.disableEdits && 
          <div>
            <Divider/>
            <FlatButton
              label=""
              fullWidth={true}
              primary={true}
              onClick={() => this.props.onNew({
                patient: true
              })}
              icon={<Add color={grey500} />}
            />
          </div>}
      </div>
    )
  }
};

export default ContactList;


// WEBPACK FOOTER //
// ./src/ContactList.js